// Wiring between the Service Worker and the running app for fresh-manifest
// notifications.
//
// The SW posts `{type: "manifest-updated", generated_at, schema_version}` on
// BroadcastChannel("agg-manifest") when its StaleWhileRevalidate revalidation
// pulls a newer manifest.json. The app listens, reloads from IndexedDB, and
// re-renders.
//
// This is what keeps user-visible staleness inside the 10-minute budget:
// without it, SWR would serve stale until the user manually reloads.

export const CHANNEL_NAME = "agg-manifest";

export interface ManifestUpdatedMessage {
  type: "manifest-updated";
  generated_at: number;
  schema_version: number;
}

export type ManifestMessage = ManifestUpdatedMessage;

export function subscribe(onUpdate: (msg: ManifestUpdatedMessage) => void): () => void {
  if (typeof BroadcastChannel === "undefined") {
    // Safari < 15.4 etc. — fall back to no-op. The Workbox SW posts via
    // postMessage to clients as well, registered separately by the
    // workbox-window helper.
    return () => undefined;
  }
  const ch = new BroadcastChannel(CHANNEL_NAME);
  const handler = (ev: MessageEvent<ManifestMessage>) => {
    if (ev.data?.type === "manifest-updated") {
      onUpdate(ev.data);
    }
  };
  ch.addEventListener("message", handler);
  return () => {
    ch.removeEventListener("message", handler);
    ch.close();
  };
}
